require('framework/polyfills').then(() => {
    require('framework/vendors');
    require('framework/desktop.ui');
    $.getScript(require('framework/get_setup_url'), () => {
        require('framework/requirejs.proxy');
        $(() => require('../desktop.secure'));
    });
});
